import lang from 'lang'
import { subscriptionModuleTypes } from 'modules/base/util/constants'

const getTexts = (type) => {
  const isGmi = type === subscriptionModuleTypes.GMI
  return {
    title: lang.subscriptionSelectionTitle,
    subTitle: type ? lang.subscriptionSelectionTitleByProduct[type] : '',
    hints: {
      month: isGmi ? lang.subscriptionSelectionHintMonthGMI : lang.subscriptionSelectionHintMonth,
      year: lang.subscriptionSelectionHintYear,
    },
    item: {
      cancelText: '',
      currencyLabel: `${lang.currencyEuro}**`,
      currencyPrecision: 2,
      currencySymbol: '',
      descriptionSuffix: '*',
      periodLabels: {
        month: '',
        year: '',
      },
    },
  }
}

export default getTexts
